import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "whatsapp"
const WhatsappIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M9.434 7.494Q9.575 7.513 9.656 7.512 9.88 7.512 9.966 7.588 10.057 7.663 10.149 7.908 10.243 8.141 10.535 8.931T10.83 9.803Q10.83 10.046 10.424 10.472 10.02 10.896 10.02 11.012C10.022 11.074 10.042 11.135 10.078 11.187Q10.477 12.035 11.273 12.779 11.929 13.394 13.043 13.953 13.183 14.034 13.301 14.034 13.477 14.034 13.934 13.478 14.39 12.908 14.543 12.908 14.697 12.907 15.685 13.417 16.675 13.929 16.735 14.034 16.762 14.121 16.758 14.21 16.758 14.593 16.558 15.093 16.372 15.546 15.728 15.853 15.08 16.164 14.53 16.164 13.864 16.163 12.305 15.443C11.562 15.11 10.887 14.643 10.313 14.07Q9.469 13.222 8.577 11.92 7.733 10.674 7.747 9.663V9.57Q7.78 8.512 8.612 7.732C8.775 7.572 8.994 7.482 9.223 7.478Q9.293 7.478 9.433 7.494" />
          <path
            fillRule="evenodd"
            d="M12.164 3Q13.957 3.001 15.592 3.698C16.643 4.138 17.599 4.773 18.409 5.57 19.212 6.374 19.854 7.323 20.297 8.366 20.764 9.44 21.003 10.598 21 11.768 21.003 12.937 20.764 14.094 20.297 15.168 19.854 16.212 19.213 17.161 18.409 17.965 17.6 18.76 16.643 19.397 15.592 19.836 14.51 20.299 13.342 20.537 12.164 20.534Q9.878 20.534 7.887 19.441L3 21 4.594 16.291C3.755 14.93 3.318 13.363 3.329 11.768Q3.33 9.989 4.032 8.366C4.475 7.323 5.115 6.374 5.918 5.57 6.727 4.774 7.681 4.14 8.73 3.698 9.815 3.235 10.984 2.998 12.164 3M12.164 4.466C11.183 4.464 10.211 4.66 9.311 5.046 8.434 5.413 7.636 5.943 6.96 6.607 6.292 7.275 5.759 8.066 5.39 8.935 5.002 9.83 4.802 10.795 4.805 11.769Q4.805 14.128 6.21 16.046L5.285 18.755 8.121 17.86C9.317 18.654 10.724 19.075 12.163 19.068L12.164 19.07C13.145 19.072 14.117 18.874 15.018 18.49 15.894 18.122 16.692 17.593 17.368 16.928 18.035 16.26 18.568 15.47 18.937 14.6 19.326 13.707 19.526 12.742 19.523 11.769 19.526 10.794 19.326 9.83 18.938 8.937 18.569 8.067 18.036 7.275 17.368 6.605 16.691 5.941 15.893 5.412 15.017 5.047 14.117 4.66 13.145 4.464 12.164 4.466"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default WhatsappIcon
